module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1600.db110797.svg";